<!-- TODO: A supprimer quand l'implémentation v10 sera terminée -->
<custom-frame [frame]="'traductionMessages'" [isTitleHidden]="true"></custom-frame>